import React from "react";
import createClass from "create-react-class";
import Testimonial from '../Testimonial/Testimonial';
import SnappServicesContent from '../../../config/SnappServicesContent';

require("../../../../less/SnappServices.less");
const SnappServicesSection = createClass({
  render() {
    return (
      <div className="root">
        <div className="header-container">
         <h1 className="header"> آشنایی با سرویس‌های اسنپ!</h1>
        </div>
        <p className="snapp-description">
          سوپراپلیکیشن اسنپ!، با ارائه راهکارهای جدید برای نیازهای مختلف، 
          زندگی شما را هوشمند می‌کند. سادگی، سرعت و مقرون به صرفه بودن شعار اسنپ است 
          و در تمام سرویس‌های این مجموعه به عنوان اولویت‌های اصلی شناخته می‌شود.
        </p>
        <div className="snapp-services-container">
        {SnappServicesContent.map((item) => {
          return(
            <Testimonial
              testimonialImage={item.img}
              testimonialTitle={item.title}
              titleIntro={item.titleIntro}
              testimonialDescription={item.desc}
              link={item.link}
              linkAble={item.linkAble}


          
          />
          )
        })}
        </div>
      </div>
    )
  }
});

module.exports = SnappServicesSection;


// WEBPACK FOOTER //
// ./src/js/components/Pages/SnappServices/SnappServicesSection.js